<template>
    <div class="row left-nav-collapsible">
        <div v-if="detailPageOpen" id="detail-page-open">
            <button class="btn details-open-btn" type="button" @click="onDetailPageOpenClose(false)">
                <span> <i class="fa fa-caret-right"></i></span>
            </button>
        </div>
        <TransitionGroup :name="'slide'" key="detail">
            <div v-if="showCloseBtn && !detailPageOpen" id="detail-page-close" key="close">
                <button class="btn text-start details-open-btn" type="button" @click="onDetailPageOpenClose(true)">
                    <span> <i class="fa fa-caret-left"></i></span>
                </button>
            </div>
            <div class="col-3" v-if="!detailPageOpen" id="details-col" @mouseover="onDetailPageHover(true)"
                key="details-col">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-header-title">Deployment Details</h4>
                    </div>
                    <div class="card-body">
                        <div v-if="loading">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="spinner-border spinner-border-sm me-2" role="status"
                                    style="width: 1em; height: 1em;">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p style="padding-top: 15px;">Loading deployment details...</p>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="deployment">
                                <div class="list-group list-group-flush" style="font-size: 0.85rem;">
                                    <div class="list-group-item" v-if="deployment?.id">
                                        <div class="row">
                                            <div class="col">
                                                <span>Deployment ID</span>
                                            </div>
                                            <div class="col-auto text-muted">
                                                <strong>{{ deployment.id }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-group-item" v-if="deployment?.sandbox">
                                        <div class="row">
                                            <div class="col">
                                                <span>Sandbox</span>
                                            </div>
                                            <div class="col-auto text-muted">
                                                <span>{{ deployment.sandbox }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-group-item" v-if="deployment?.job_stack">
                                        <div class="row">
                                            <div class="col">
                                                <span>Job Stack</span>
                                            </div>
                                            <div class="col-auto text-muted">
                                                <span>{{ deployment.job_stack }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-group-item" v-if="deployment?.deployed_by">
                                        <div class="row">
                                            <div class="col">
                                                <span>Deployed By</span>
                                            </div>
                                            <div class="col-auto text-muted">
                                                <strong>{{ deployment.deployed_by }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-group-item" v-if="deployment?.deployed_at">
                                        <div class="row">
                                            <div class="col">
                                                <span>Deployed At</span>
                                            </div>
                                            <div class="col-auto text-muted">
                                                <strong>{{ DateTimeFormat(deployment.deployed_at) }}</strong>
                                                <span class="ms-2 badge badge-secondary">{{
                                                    convertToRelativeTime(deployment.deployed_at) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-center">
                                No data found!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col" id="main-col" @mouseover="onDetailPageHover(false)" key="main-col">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                        <h4 class="card-header-title">Pipeline Flow</h4>
                        <div class="d-flex align-items-center justify-content-end">
                            <div>
                                <div class="mt-1"
                                    v-if="pipelineExecutionDetails?.status == 'RUNNING' || pipelineExecutionDetails?.status == 'SUBMITTED'">
                                    <span class="spinner-border spinner-border-sm me-1" role="status"
                                        style="width: 1em; height: 1em;">
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                </div>
                            </div>
                            <span class="badge bg-secondary steps-badge"
                                v-if="pipelineExecutionDetails?.total && pipelineExecutionDetails?.completed">
                                {{ pipelineExecutionDetails?.completed }}/{{ pipelineExecutionDetails?.total }}
                                Jobs
                            </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="isLoadingPipeline || loading">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="spinner-border spinner-border-sm me-2" role="status"
                                    style="width: 1em; height: 1em;">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p style="padding-top: 15px;">Loading pipeline details...</p>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="jobs.length > 0 && pipelineJobConfig" style="height: 500px">
                                <pipelineGraph :pipelineExecutionDetails="pipelineExecutionDetails"
                                    :pipelineJobConfig="pipelineJobConfig" :jobs="jobs">
                                </pipelineGraph>
                            </div>
                            <div v-else class="text-center">
                                No data found!
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header p-4 ">
                        <h4 class="card-header-title d-flex align-items-center">
                            <span>Jobs Created</span>
                            <span class="fa fa-circle-info text-muted ms-2"
                                title="List of jobs created in this deployment" data-bs-toggle="tooltip"
                                data-bs-placement="right" style="font-size: 0.8rem;"></span>
                        </h4>
                    </div>
                    <div class="card-body">
                        <div v-if="deployment?.jobs && deployment.jobs.length > 0">
                            <div class="list-group list-group-flush pb-1">
                                <div v-for="(job, index) in deployment?.jobs" :key="index"
                                    class="list-group-item job-list-item">
                                    <button class="btn btn-link text-decoration-none link-primary job-link-btn"
                                        @click="redirectToSanboxJob(job)">
                                        <strong>{{ job.name }}</strong>
                                        <span class="badge badge-secondary ms-2" v-if="job.kind == 'PIPELINE'">{{
                                            job.kind }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center">
                            No data found!
                        </div>
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { DateTimeFormat, relativeTime } from '../../utils/commonFunction';
import pipelineGraph from "./pipelineGraph.vue";
export default {
    name: 'JobStackDeploymentDetailsPipeline',
    components: { pipelineGraph },
    props: ["loading", "editMode", "deployment", "jobs", "isLoadingPipeline", "pipelineExecutionDetails"],
    data() {
        return {
            showCloseBtn: false,
            detailPageOpen: false,
        };
    },
    methods: {
        DateTimeFormat,
        convertToRelativeTime(timestamp) {
            return relativeTime(Date.now(), dayjs(timestamp));
        },
        redirectToSanboxJob(job) {
            this.$router.push({
                name: "Sandbox Job Configuration",
                params: {
                    sandboxId: `${this.deployment.sandbox}`,
                    jobId: `${job.name}`
                },
            });
        },
        onDetailPageOpenClose(value) {
            this.showCloseBtn = false;
            this.detailPageOpen = value;
        },
        onDetailPageHover(value) {
            this.showCloseBtn = value;
        },
    },
    computed: {
        pipelineJobConfig() {
            return this.jobs.find(job => job.jobDetails?.kind.toLowerCase() === 'pipeline');
        },
    },
    beforeMount() {
        this.$emit('setRunAllButton', true);
    },
    beforeUnmount() {
        this.$emit('setRunAllButton', false);
    },
}
</script>

<style scoped>
.job-list-item {
    padding: 0.75rem 1rem;
    border: 1.5px solid #e9ecef;
    border-radius: 0.375rem;
    margin-bottom: 0.5rem;
    transition: all 0.2s ease-in-out;
    background-color: #f8f9fa;
}

.job-list-item:hover {
    background-color: #fff;
    border-color: #0d6efd;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.job-list-item:last-child:hover {
    border-bottom-color: #0d6efd;
}

.job-list-item:last-child {
    margin-bottom: 0;
    border-bottom: 1.5px solid #e9ecef;
}

.job-link-btn {
    width: 100%;
    text-align: left;
    padding: 0;
    color: #0d6efd;
    font-size: 0.95rem;
    transition: color 0.2s ease-in-out;
}

.job-link-btn:hover {
    color: #0a58ca;
}

.job-link-btn i {
    font-size: 0.9rem;
    opacity: 0.8;
}

.job-link-btn strong {
    font-weight: 500;
}

.steps-badge {
    font-size: 0.75rem;
    padding-left: 0.5rem;
}
</style>